import React from 'react';
import _ from 'lodash';
import component, {makePath, classnames} from './component';
import routes from '../routes';
import queryString from 'query-string';

export default component('Link', {

  getInitialState() {
    return {
      selectedCurrent: false,
      selectedParent: false,
      selectedDefault: false
    }
  },

  _removeEmptyKeys(o) {
    return _.pick(o, _.identity);
  },

  _leaveOnlyKeysInStaticQuery(o) {
    return _.pick(o, _.keys(this.props.queryStatic));
  },

  _getUrl(includeFullQuery = true) {
    let q = this._removeEmptyKeys(this.props.query);
    if (!includeFullQuery) {
      q = this._leaveOnlyKeysInStaticQuery(q);
    }
    return this.props.href || makePath(this.props.name, this.props.params || {}, q);
  },

  _updateSelected() {
    let selectedCurrent = document.location.pathname + document.location.search === this._getUrl();
    if (!selectedCurrent) {
      const qs = queryString.stringify(this._leaveOnlyKeysInStaticQuery(queryString.parse(document.location.search)));
      const pq = document.location.pathname + `?${qs}`;
      var selectedParent = pq.indexOf(this._getUrl(false)) === 0;
      if(!selectedParent){
        var selectedDefault =  typeof document !== 'undefined' && !document.location.search.length && this.props.defaultSelected
      }
    }

    this.setState({selectedCurrent, selectedParent, selectedDefault});
  },

  componentDidMount() {
    this._updateSelected();
  },

  componentDidUpdate() {
    this._updateSelected();
  },

  clickHandler(e) {
    if (e.metaKey) {
      return;
    }
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick(e);
    }
    routes.navigateTo(this._getUrl(), false, this.props.keepScroll);
  },

  render() {
    const href = this._getUrl();
    const props = {...this.props, href};
    if (href.substring(0, 4) === 'http') {
      props.target = '_blank';
    } else {
      props.onClick = this.clickHandler
    }
    props.className = classnames(
      'Link',
      this.props.className,
      {
        'Link--SelectedCurrent': this.state.selectedCurrent || this.state.selectedDefault,
        'Link--SelectedParent': this.state.selectedParent
      }
    );
    return (
      <a {...props}/>
    );
  }

});



// WEBPACK FOOTER //
// ./src/components/Link.js